export const InitialState = {
    auth: {
        oauthNonce: '',
        oauthState: '/',
    },
};

export type StateType = typeof InitialState;
